import { h } from 'preact';
import PropTypes from 'prop-types';

import { IconPlayBlurred } from '../../1-foundation/icons/icons';
import { getTimeElapsed } from '../../../../utils/dates';
import { getClassNames } from '../../../../utils/classnames-utils';
import Wrapper from '../../1-foundation/wrapper/wrapper';
import { getLabel } from '../../../../labels/labelling-service';

import { modifierList } from './props-list';

const DEFAULT_MODIFIERS = [];
const DEFAULT_TAG = 'button';

const VideoCardInline = ({
  index,
  modifiers = DEFAULT_MODIFIERS,
  onClick,
  hasPlayIcon,
  isPlaying,
  imageSrc,
  title,
  duration,
  publishedTime,
  time,
  showPosition,
  tag = DEFAULT_TAG,
  href,
  intcmp,
}) => {
  const Tag = tag;
  const tagType = tag === 'button' ? 'button' : undefined;
  const tagHref = tag === 'button' ? undefined : href;
  const classNames = getClassNames('c-video-card-inline', modifiers);
  const isOnPopup = classNames.includes('on-popup');
  const positionLabel = index + 1;
  const timeToShow = publishedTime && duration ? `${duration} MIN | ${getTimeElapsed(publishedTime)}` : time;

  return (
    <Tag className={classNames} onClick={(e) => onClick(index, e)} type={tagType} href={tagHref} data-intcmp={intcmp}>
      <article className="c-video-card-inline__wrapper">
        {showPosition && <div className="c-video-card-inline__position">{positionLabel}</div>}
        <div
          className={`c-video-card-inline__img-container o-aspect-ratio ${!isOnPopup ? 'o-aspect-ratio--16-9' : ''}`}
        >
          {isOnPopup && isPlaying && (
            <div className="c-video-card-inline__is-playing-overlay">{getLabel('videocardinline.is.playing')}</div>
          )}
          <img className="c-video-card-inline__img" src={imageSrc} alt={title} />
          {hasPlayIcon && <IconPlayBlurred modifiers={['media', 'play-blurred', 'medium']} />}
        </div>
        <Wrapper tag="div" className="c-video-card-inline__info-wrapper" isWrapping={isOnPopup}>
          <h4 className="c-video-card-inline__title">{title}</h4>
          <time className="c-video-card-inline__info" dateTime={timeToShow}>
            {timeToShow}
          </time>
        </Wrapper>
      </article>
    </Tag>
  );
};

VideoCardInline.propTypes = {
  tag: PropTypes.string,
  href: PropTypes.string,
  onClick: PropTypes.func,
  modifiers: PropTypes.arrayOf(PropTypes.oneOf(modifierList)),
  index: PropTypes.number,
  hasPlayIcon: PropTypes.bool,
  isPlaying: PropTypes.bool,
  imageSrc: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  duration: PropTypes.string,
  publishedTime: PropTypes.string,
  time: PropTypes.string,
  showPosition: PropTypes.bool,
  intcmp: PropTypes.string,
};

export default VideoCardInline;
